import { cloneDeep } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppBundle } from 'api/optimalprint-sdk.d';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import styles from './Breadcrumbs.module.scss';

const isLast = (list: any[], index: number) => index === list.length - 1;

interface Props {
  extraCrumb?: string;
}
const Breadcrumbs = ({ extraCrumb }: Props) => {
  const category = useSelector(getCurrentCategory);

  if (!category) {
    return null;
  }
  const breadCrumbs = cloneDeep(category.breadcrumbs);
  if (extraCrumb) {
    breadCrumbs.push({
      title: extraCrumb,
    } as AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response.Breadcrumb);
  }
  const reactOrExternalLink = (url: string, title: string, index: number) => {
    if (index > 1) {
      return <Link to={url}>{title}</Link>;
    }
    return (
      <a href={url} title="">
        {title}
      </a>
    );
  };

  return (
    <div className={styles.breadcrumbs}>
      {breadCrumbs.map((crumb, index) => (
        <React.Fragment key={`bc_${index}`}>
          {crumb.url && !isLast(breadCrumbs, index) && reactOrExternalLink(crumb.url, crumb.title, index)}
          {(!crumb.url || isLast(breadCrumbs, index)) && crumb.title}
          {!isLast(breadCrumbs, index) && <span>&nbsp;/&nbsp;</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
